<template>
    <div id="app" @click="isOpen = false">
        <div class="main">
            <img class="banner" src="@/assets/images/habby_del_account_topbar@2x.png" alt="" />
            <div class="menu">
                <div class="menu_left">
                    <img v-if="ruleForm.gameName == 'matchmart'" src="@/assets/images/logo_matchmart.png" alt="" />
                    <img v-else-if="ruleForm.gameName == 'survivor'" src="@/assets/images/logo_survivor.png" alt="" />
                    <img v-else-if="ruleForm.gameName == 'archero'" src="@/assets/images/logo_archero.png" alt="" />
                    <img v-else-if="ruleForm.gameName == 'Archero2'" src="@/assets/images/logo_archero2.png" alt="" />
                    <img v-else-if="ruleForm.gameName == 'Souls'" src="@/assets/images/logo_Souls.png" alt="" />
                    <img v-else-if="ruleForm.gameName == 'Wittle Defender'" src="@/assets/images/logo_WittleDefender.png" alt="" />
                    <img v-else-if="ruleForm.gameName == 'Monster Must Die'" src="@/assets/images/logo_MonsterMustDie.png" alt="" />
                    <img v-else="ruleForm.gameName == 'Punball'" src="@/assets/images/logo_Punball.png" alt="" />
                </div>
                <!-- 下拉选中语言 -->
                <div class="dropdown" ref="dropdown">
                    <div class="selected-option" @click.stop="isOpen = !isOpen" v-show="showPage == '1' && showBoxPage == '1'">
                        <div>
                            <img draggable="false" style="width: 1.25rem;" src="@/assets/images/language_FILL0_wght400_GRAD0_opsz24@2x.png" alt="" />
                            <span class="text">{{ optionLANG }}</span>
                            <img draggable="false" v-show="isOpen" src="@/assets/images/symbol_below@2x.png" alt="" />
                            <img draggable="false" v-show="!isOpen" src="@/assets/images/bottom.png" alt="" />
                        </div>
                    </div>
                    <div v-if="isOpen" class="options">
                        <div class="opt" :class="[{ 'optGree':option.value == LANG }]" v-for="option in options" :key="option.value" @click="selectOption(option)">
                            {{ option.label }}
                            <img v-show="option.value == LANG" draggable="false" src="@/assets/images/icon_done_green_small@2x.png" alt="" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="box" v-show="showBoxPage == '1'">
                <h2>{{ lang[1][LANG] }}</h2>
                <div :class="{ box_text: true, 'ar_text' : LANG == 'ar' }">
                    <span v-show="showPage == 1" v-html="lang[2][LANG]"></span>
                    <span v-show="showPage == 2">
                        {{ lang[5][LANG] }}
                        <p></p>
                        <b>{{ lang[6][LANG] }}</b>
                    </span>
                    <span v-show="showPage == 3">{{ lang[7][LANG] }}</span>
                </div>
                <div class="box_btn_wrap">
                    <div v-show="showPage !== '3'">
                        <div v-show="countdown < 1" class="box_btn" @click="onClickNext">
                            {{ lang[3][LANG] }}
                        </div>
                        <div v-show="countdown > 0" class="box_btn box_btn_dis">
                            {{ lang[3][LANG] }} <span >({{countdown}}s)</span>
                        </div>
                    </div>
                    
                    <div v-show="showPage == 3" class="box_btn box_btn_re" @click="showPage = '1'; initSet()">
                        {{ lang[17][LANG] }}
                    </div>
                    <div v-show="showPage == 3" class="box_btn" @click="onClickNext">
                        {{ lang[4][LANG] }}
                    </div>

                </div>
            </div>
            <div  class="box" v-show="showBoxPage == '2'">
                <h2>{{ lang[8][LANG] }}</h2>
                <h5>{{ lang[9][LANG] }}</h5>
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="form_wrap">
                    <el-form-item prop="userId">
                        <div class="label">
                            {{ lang[10][LANG] }}
                            <el-tooltip effect="dark" :content="lang[11][LANG]" placement="top">
                                <img src="@/assets/images/icon_info.png" alt="" />
                            </el-tooltip>
                        </div>
                        <el-input v-model="ruleForm.userId" :placeholder="lang[10][LANG]"></el-input>
                    </el-form-item>
                    <el-form-item prop="fromEmail">
                        <div class="label">
                            {{ lang[12][LANG] }}
                        </div>
                        <el-input v-model="ruleForm.fromEmail" :placeholder="lang[12][LANG]"></el-input>
                    </el-form-item>
                </el-form>
                <div class="box_btn_wrap">
                    <div :class="['box_btn', {'box_btn_dis':!isDisable}]" @click="onClickSubmit">
                        {{ lang[15][LANG] }}
                    </div>
                </div>
            </div>
            <div class="box" v-show="showBoxPage == '3'">
                <img class="icon_success" src="@/assets/images/icon_success.png" alt="" />
                <h3>{{ lang[16][LANG] }}</h3>
            </div>
        </div>
    </div>
</template>

<script>
import { lang } from './assets/js/lang.js'
import { myHTTP } from './utils/net'
import { langList } from './utils/lang'
import queryString from 'query-string'

var parsed = queryString.parse(location.search || '') || {}

export default {
    name: 'App',
    data() {
        var validateId = (rule, value, callback) => {
            if (value === '') {
                callback(new Error(this.lang[13][this.LANG]))
            } else {
                callback()
            }
        }
        var validateRedemption = (rule, value, callback) => {
            let emailRegex = /^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/;
            if (emailRegex.test(value)) {
                callback();
            } else {
                callback(new Error(this.lang[14][this.LANG]));
            }
        }
        return {
            showBoxPage: '1',
            showPage: '1',
            LANG: 'en',
            optionLANG: 'English',
            lang,
            dropdown: null,
            isOpen: false,
            options: langList,
            countdown: -1,
            intervalId: null,
            ruleForm: {
                userId: '',
                fromEmail: '',
                gameName: ''
            },
            rules: {
                userId: [{ required: true, trigger: ['blur', 'change'], validator: validateId }],
                fromEmail: [{ type:'email', required: true, trigger: ['blur', 'change'], validator: validateRedemption }],
            },
        }
    },
    computed: {
        isDisable() {
            let emailRegex = /^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/;
            let a = emailRegex.test(this.ruleForm.fromEmail)
            let b = this.ruleForm.userId ? true : false
            return a && b;
        }
    },
    created() {
        this.initLANG()
        this.initSet()
        this.ruleForm.gameName = parsed.game || 'Punball'
    },
    methods: {
        initSet() {
            this.countdown = 8
            this.intervalId = setInterval(() => {
                this.countdown--;
                if (this.countdown < 0) {
                    clearInterval(this.intervalId);
                }
            }, 1000);
        },
        onClickNext() {
            this.isOpen = false
            if (this.countdown == '0') {
                return
            }
            if (this.showPage == '1') {
                this.showPage = '2'
                this.countdown = 8;
                this.intervalId = setInterval(() => {
                    this.countdown--;
                    if (this.countdown < 0) {
                        clearInterval(this.intervalId);
                    }
                }, 1000);
                return
            }
            if (this.showPage == '2') {
                this.showPage = '3'
                return
            }
            if (this.showPage == '3') {
                this.showBoxPage = '2'
                this.showPage = '1'
                return
            }
        },
        selectOption (option){
            this.LANG = option.value;
            this.optionLANG = option.label;
            this.isOpen = false;
            this.$refs['ruleForm'].resetFields();
        },
        onClickSubmit() {
            if (!this.isDisable) {
                return
            }
            myHTTP
                .post(`/api/v1/cancellation`, {
                    ...this.ruleForm
                })
                .then(res => {
                    console.log(res, 'res')
                    if (res.data && res.data.success) {
                        this.showBoxPage = '3'
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message || '错了哦，这是一条错误消息',
                            type: 'error'
                        });
                    }
                })
                .catch(error => {
                    this.isDisable = false
                })
        },
        getLabel(value) {
            let item = this.options.find(lang => lang.value === value);
            return item ? item.label : '';
        },
        initLANG() {
            let language = navigator.language.toLowerCase()
            if (parsed.gameLanguage) {
                language = parsed.gameLanguage
            }
            if (language.startsWith('zh')) {
                if ('zh-cn' == language || 'zh-CN' == language || 'zh' == language) {
                    this.LANG = 'zh-CN'
                } else {
                    this.LANG = 'zh-TW'
                }
            } else if (language.startsWith('ja')) {
                this.LANG = 'ja'
            } else if (language.startsWith('ko')) {
                this.LANG = 'ko'
            } else if (language.startsWith('ru')) {
                this.LANG = 'ru'
            } else if (language.startsWith('pt')) {
                this.LANG = 'pt'
            } else if (language.startsWith('fr')) {
                this.LANG = 'fr'
            } else if (language.startsWith('de')) {
                this.LANG = 'de'
            } else if (language.startsWith('es')) {
                this.LANG = 'es'
            } else if (language.startsWith('ar')) {
                this.LANG = 'ar'
            } else if (language.startsWith('id')) {
                this.LANG = 'id'
            } else if (language.startsWith('it')) {
                this.LANG = 'it'
            } else if (language.startsWith('vi')) {
                this.LANG = 'vi'
            } else if (language.startsWith('th')) {
                this.LANG = 'th'
            } else if (language.startsWith('tr')) {
                this.LANG = 'tr'
            } else {
                this.LANG = 'en'
            }
            this.optionLANG = this.getLabel(this.LANG);
            console.log(this.LANG, 'LANG')
            // 禁止双指放大
            document.documentElement.addEventListener(
                'touchstart',
                function (event) {
                    if (event.touches.length > 1) {
                        event.preventDefault()
                    }
                },
                false
            )
            var lastTouchEnd = 0
            document.documentElement.addEventListener(
                'touchend',
                function (event) {
                    var now = Date.now()
                    if (now - lastTouchEnd <= 300) {
                        event.preventDefault()
                    }
                    lastTouchEnd = now
                },
                false
            )
            document.addEventListener('gesturestart', function (event) {
                event.preventDefault()
            })
            ;(function (doc, win) {
                var docEl = doc.documentElement, //文档根标签
                    resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize', //viewport变化事，获取移动端屏幕是否翻转件源
                    recalc = function () {
                        //重置方法
                        var clientWidth = docEl.clientWidth
                        var clientHeight = docEl.clientHeight
                        if (!clientWidth) return
                        // 改变DOM根节点fontSize大小的值;
                        // (屏幕宽度/设计图宽度) = 缩放或扩大的比例值;
                        if (clientWidth > 900) {
                            docEl.style.fontSize = '16px'
                        } else {
                            docEl.style.fontSize = 16 * (clientWidth / 900) + 'px'
                        }
                    }
                if (!doc.addEventListener) return
                win.addEventListener(resizeEvt, recalc, false)
                doc.addEventListener('DOMContentLoaded', recalc, false)
            })(document, window)
        }
    }
}
</script>

<style lang="less">
html,
body {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    // overflow: hidden;
}
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    width: 100%;
    background: #ECEEF1;
    height: 100%;
    .main {
        width: 100%;
        max-width: 900px;
        margin: 0 auto;
        font-weight: bold;
        background: #eceef1;
        position: relative;
        .banner {
            height: auto;
            width: 100%;
            display: block;
        }
        .menu {
            display: flex;
            justify-content: space-between;
            align-items: center;
            position: absolute;
            top: 0;
            left: 0;
            width: 94%;
            height: 7rem;
            margin: 0 auto;
            padding: 0 3%;
            .menu_left {
                img {
                    margin-top: .5rem;
                    width: 4.6875rem;
                    border-radius: 1rem;
                }
            }
            .dropdown {
                position: relative;
                margin-left: 1.25rem;
                color: #fff;

                .selected-option {
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    height: 100%;
                    transform: translateY(.4rem);
                    div {
                        border-radius: .625rem;
                        display: inline-block;
                        height: 2rem;
                        display: flex;
                        align-items: center;
                        justify-content: space-around;
                        min-width: 7.875rem;
                        font-size: 1.375rem;
                        padding: 0 .375rem;
                        .text {
                            padding: 0 .5rem;
                        }
                    }
                    
                    img {
                        width: 1rem;
                        padding: 0;
                        margin: 0;
                    }
                }
                
                .options {
                    z-index: 100;
                    width: 13.75rem;
                    position: absolute;
                    top: 100%;
                    right: 0;
                    margin-top: .3125rem;
                    padding: .875rem;
                    list-style: none;
                    color: #000;
                    background-color: #fff;
                    border: .125rem solid #000;
                    border-radius: .875rem;

                    .opt {
                        height: 3rem;
                        padding: 0 .875rem;
                        border-radius: .5625rem;
                        line-height: 3rem;
                        cursor: pointer !important;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        img {
                            height: 1rem;
                        }
                    }
                    .optGree {
                        color: #00D67D;
                    }
                    .opt:hover {
                        background-color: #F3F3F4;
                    }
                }
            }
            
        }

        .box {
            padding: 4.625rem 0 0;
            display: flex;
            flex-direction: column;
            align-items: center;
            .icon_success {
                width: 14vw;
                max-width: 120px;
                margin: 14vh 0 2.125rem;
            }

            h2 {
                font-weight: 500;
                font-size: 2rem;
                color: #191919;
                line-height: 2.8125rem;
                text-align: center;
                margin: 0;
            }
            h5 {
                margin: .625rem 0 0;
                font-weight: 500;
                font-size: 1.125rem;
                color: #9C9CA3;
                line-height: 1.5625rem;
                width: 46%;
            }
            .box_text {
                margin-top: 1.8rem;
                background: #fff;
                width: 42.875rem;
                height: 36vh;
                font-weight: 400;
                font-size: 1.3125rem;
                color: #191919;
                line-height: 2.125rem;
                text-align: left;
                font-style: normal;
                border-radius: .625rem;
                overflow: auto;
                padding: 2rem;
                span {
                    p {
                        height: 1.2rem;
                        margin: 0;
                    }
                    b {
                        font-weight: 400;
                        color: #FF0000;
                    }   
                }
            }
            .ar_text {
                text-align: right;
                direction: rtl;
            }
            .form_wrap {
                width: 34.0625rem;
                margin-top: 1.875rem;
                .label {
                    text-indent: 1rem;
                    text-align: left;
                    font-weight: 600;
                    font-size: 1.625rem;
                    color: #191919;
                    height: 3rem;
                    img {   
                        margin-left: .625rem;
                        width: 1.5rem;
                        cursor: pointer;
                    }
                }
                .el-form-item {
                    margin-bottom: 2.5rem;
                    input {
                        width: 100%;
                        height: 4rem;
                        color: #B5B5BE  ;
                        font-weight: 600;           
                        font-size: 1.425rem;
                        border: .1875rem solid #606071;
                        border-radius: .625rem;
                    }
                    .el-form-item__error {
                        text-indent: .2rem;
                        color: #FF0000;
                        width: 100%;
                        font-weight: 500;
                        font-size: 1.125rem;
                        margin-top: .175rem;
                        text-align: left;
                    }
                }
                
            }

            .box_btn_wrap {
                margin-top: 5.25rem;
                display: flex;
                justify-content: space-evenly;
                width: 100%;

                .box_btn {
                    display: inline-block;
                    width: 18.375rem;
                    height: 5.4375rem;
                    font-weight: 600;
                    font-size: 1.875rem;
                    color: #FFFFFF;
                    line-height: 5.4375rem;
                    text-align: center;
                    background: #3E3E4E;
                    border-radius: 6.75rem;
                    cursor: pointer;
                }
                .box_btn_dis {
                    color: #707082;
                    cursor: no-drop;
                }
                .box_btn_re {
                    color: #3E3E4E;
                    background: #fff;
                    border: .1875rem solid #3E3E4E;
                    box-sizing: border-box;
                }
            }
            
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/App.vue